import Vue from 'vue'
import Eject from './Eject.vue'

const EjectBox = Vue.extend(Eject)

Eject.install = function (data) {
  let instance = new EjectBox({
    data
  }).$mount()

  document.body.appendChild(instance.$el)

  Vue.nextTick(() => {
    instance.show = true
  })
}
export default Eject


// WEBPACK FOOTER //
// ./src/components/Eject.js